window.initButtonCharacterStagger = function() {
    const offsetIncrement = 0.01; // Transition offset increment in seconds
    const INLINE_TAGS = ['SPAN', 'EM', 'STRONG', 'B', 'I'];
    const buttons = document.querySelectorAll('[data-button-animate-chars]');

    buttons.forEach(button => {
        // Skip if already processed (check if text container with character spans already exists)
        const existingTextContainer = button.querySelector('div > span[style*="transition-delay"]');
        if (existingTextContainer) {
            return;
        }

        // Collect segments (text pieces with optional inherited className) and icon elements
        const childNodes = Array.from(button.childNodes);
        const segments = []; // { text: string, className: string }
        const otherElements = []; // icon wrappers to keep as-is

        childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                const t = node.textContent;
                if (t) segments.push({ text: t, className: '' });
            } else if (node.nodeType === Node.ELEMENT_NODE) {
                if (node.classList.contains('btn-animate-icon-wrapper')) {
                    otherElements.push(node);
                } else if (INLINE_TAGS.includes(node.tagName)) {
                    // Inline text element: absorb its text, carry its classes and optional gap
                    const t = node.textContent;
                    if (t) segments.push({ text: t, className: node.className, gap: node.dataset.buttonAnimateGap || '' });
                } else {
                    otherElements.push(node);
                }
            }
        });

        const totalText = segments.map(s => s.text).join('').trim();
        if (!totalText) return;

        // Remove text nodes and absorbed inline elements from the DOM
        childNodes.forEach(node => {
            if (node.nodeType === Node.TEXT_NODE) {
                node.remove();
            } else if (node.nodeType === Node.ELEMENT_NODE &&
                       !node.classList.contains('btn-animate-icon-wrapper') &&
                       INLINE_TAGS.includes(node.tagName)) {
                node.remove();
            }
        });

        // Create container for character spans
        const textContainer = document.createElement('div');
        textContainer.style.display = 'inline-block';
        textContainer.style.whiteSpace = 'nowrap';
        textContainer.style.overflow = 'hidden';

        const iconIsLeft = button.dataset.iconPosition === 'left';

        // Icon left: icon animates first (delay 0), text chars start after
        const charStartIndex = iconIsLeft && otherElements.length > 0 ? 1 : 0;
        let charIndex = charStartIndex;
        segments.forEach(({ text, className, gap }) => {
            let isFirstChar = true;
            [...text.trim()].forEach(char => {
                const span = document.createElement('span');
                if (className) span.className = className;
                span.textContent = char === ' ' ? ' ' : char;
                span.style.transitionDelay = `${charIndex * offsetIncrement}s`;
                if (isFirstChar && gap) {
                    span.style.marginLeft = gap;
                    isFirstChar = false;
                }
                textContainer.appendChild(span);
                charIndex++;
            });
        });

        // Insert text container respecting icon position
        if (otherElements.length > 0 && !iconIsLeft) {
            button.insertBefore(textContainer, otherElements[0]);
        } else {
            button.appendChild(textContainer);
        }

        // Icon delay: first when left (delay 0), last when right
        const iconInner = button.querySelector('.btn-animate-icon-inner');
        if (iconInner) {
            const delay = iconIsLeft ? '0s' : `${charIndex * offsetIncrement}s`;
            Array.from(iconInner.children).forEach(child => {
                child.style.transitionDelay = delay;
            });
        }
    });
}

// Initialize Button Character Stagger Animation
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initButtonCharacterStagger);
} else {
    // DOM already loaded
    initButtonCharacterStagger();
}

// Shopify Theme Editor Support
if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', () => {
        initButtonCharacterStagger();
    });
}

// Force reset d'un bouton animé : reconstruit le texte depuis les spans et relance
function resetButtonCharacterStagger(button) {
    const container = button.querySelector('div');
    if (container) {
        const text = Array.from(container.querySelectorAll('span[style*="transition-delay"]'))
            .map(s => s.textContent).join('');
        container.remove();
        if (text) button.insertAdjacentText('afterbegin', text);
    }
}

// Re-init quand une modale s'ouvre (ex: dispo boutique)
document.addEventListener('modal:opened', () => {
    initButtonCharacterStagger();
});

// Re-init après rechargement HTML du footer produit (data-product-reload)
document.addEventListener('product:product-reload-complete', () => {
    initButtonCharacterStagger();
});

// Re-init après changement de card comparatif
document.addEventListener('comparatif:card-swapped', () => {
    initButtonCharacterStagger();
});
